document.addEventListener("DOMContentLoaded", function() { 
  const firstStep = document.querySelector(".quiz-first-step"); 
  const secondStep = document.querySelector(".quiz-second-step"); 
  const quizBlock = document.querySelector(".quiz-block"); 
  const quizResult = document.querySelector(".temp-thank-you"); 
  const resultsContainer = document.querySelector(".quiz-results"); 
  const resultsCategories = document.querySelector(".results-categories"); 
  const emailStep = document.querySelector(".quiz-email-step"); 
  const emailInput = document.querySelector("#user-email"); 
  const klemailInput = document.querySelector('#klaviyo_email'); 
  const firstName = document.querySelector("#firstName"); 
  const lastName = document.querySelector("#lastName"); 
  const validationMessage = document.querySelector(".validation-message"); 
  const stepsblock = document.querySelector(".steps__bar"); 
  const steps = document.querySelectorAll(".number-dots"); 
  const allGroups = document.querySelectorAll("[data-category-step]"); 
  let currentStep = 0; 
 
  let quizChoiceSelected = []; 
 
  if (emailInput && klemailInput) { 
    emailInput.addEventListener("input", function() { 
      klemailInput.value = emailInput.value; 
    }); 
  } else { 
    console.warn("Email input(s) not found in the DOM"); 
  } 
 
  document.querySelectorAll(".quiz_choice-option label").forEach(label => { 
    label.addEventListener("click", () => { 
      const input = label.querySelector("input"); 
      if (!input) return; 
       
      const selectedValue = input.type === "checkbox" || input.type === "radio" 
        ? input.value 
        : label.innerText; 
 
      if (input.type === "checkbox") { 
        if (input.checked && !quizChoiceSelected.includes(selectedValue)) { 
          quizChoiceSelected.push(selectedValue); 
        } else if (!input.checked) { 
          quizChoiceSelected = quizChoiceSelected.filter(val => val !== selectedValue); 
        } 
      } else { 
        quizChoiceSelected = [selectedValue]; 
      } 
 
      console.log("Current quiz_choice-option selection:", quizChoiceSelected); 
    }); 
  }); 
 
  function initQuiz() { 
    firstStep?.classList.add("active"); 
    secondStep?.classList.remove("active"); 
 
    allGroups.forEach((group, index) => { 
      group.classList.toggle("active", index === 0); 
      group.querySelectorAll("input[type='checkbox']").forEach(cb => (cb.checked = false)); 
    }); 
 
    steps.forEach((step, index) => { 
      step.classList.remove("active", "completed"); 
      if (index === 0) step.classList.add("active"); 
    }); 
 
    if (resultsContainer) { 
      resultsContainer.style.display = "none"; 
    } 
     
    quizResult.style.display = "none"; 
    quizChoiceSelected = []; 
    currentStep = 0; 
  } 
 
  function updateButtonStates() { 
    const currentGroup = allGroups[currentStep]; 
    if (!currentGroup) return; 
 
    const prevBtn = currentGroup.querySelector(".previous"); 
    const nextBtn = currentGroup.querySelector(".next"); 
    if (!prevBtn || !nextBtn) return; 
 
    prevBtn.style.visibility = currentStep === 0 ? "hidden" : "visible"; 
    prevBtn.style.opacity = currentStep === 0 ? "0" : "1"; 
  } 
 
  function validateEmail(email) { 
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
    return re.test(email); 
  } 
 
  function validateQuizChoice() { 
    if (quizChoiceSelected.length === 0) { 
      validationMessage.textContent = "Please select tell us about yourself options before proceeding."; 
      validationMessage.style.display = "block"; 
      return false; 
    } 
    return true; 
  } 
 
  async function sendQuizResultToKlaviyo( 
    email, 
    first_name, 
    last_name, 
    quizChoiceSelected, 
    selected, 
    totalScore, 
    categoriesText 
  ) { 
    const url = 'https://klaviyo-api-three.vercel.app/klaviyo'; 
    const options = { 
      method: 'POST', 
      headers: { 
        'Content-Type': 'application/json' 
      }, 
      body: JSON.stringify({ 
        email, 
        first_name, 
        last_name, 
        quizChoiceSelected: quizChoiceSelected?.toString(), 
        selected: selected?.toString(), 
        result1: '0 - 4 = Not Likely Mold-Related Illness', 
        result2: '5 - 9 = Possible Mold-Related Illness', 
        result3: '10+ = Probable Mold- or Biotoxin-Related Illness', 
        totalScore, 
        categoriesText 
      }) 
    }; 
 
    console.log('Options', options); 
    try { 
      const res = await fetch(url, options); 
      if (!res.ok) { 
        throw new Error(`HTTP error! Status: ${res.status}`); 
      } 
      const text = await res.text(); 
      const data = text ? JSON.parse(text) : {}; 
      console.log('Klaviyo response:', data); 
    } catch (err) { 
      console.error('Klaviyo error:', err); 
    } 
  } 
 
  function showResults(email, first_name, last_name, quizChoiceSelected, selected) { 
    let totalScore = 0; 
    let allSelectedValues = {}; 
    let categoriesText = ""; 
    let categoryScores = {}; 
 
    allGroups.forEach((group, index) => { 
      if (index < 3) { 
        const checkedValues = Array.from(group.querySelectorAll("input:checked")) 
                                 .map(cb => cb.value); 
        const checkedCount = checkedValues.length; 
 
        let categoryScore = 0; 
        if (index === 0) { 
          if (checkedCount >= 0 && checkedCount <= 4) categoryScore = 0; 
          else if (checkedCount >= 5 && checkedCount <= 7) categoryScore = 1; 
          else if (checkedCount >= 8 && checkedCount <= 10) categoryScore = 2; 
          else if (checkedCount >= 11) categoryScore = 3; 
        } else if (index === 1) { 
          if (checkedCount >= 0 && checkedCount <= 2) categoryScore = 0; 
          else if (checkedCount >= 3 && checkedCount <= 5) categoryScore = 1; 
          else if (checkedCount >= 6 && checkedCount <= 8) categoryScore = 2; 
          else if (checkedCount >= 9) categoryScore = 3; 
        } else if (index === 2) { 
          categoryScore = checkedCount; 
        } 
 
        categoryScores[`CATEGORY ${index + 1}`] = categoryScore; 
        totalScore += categoryScore; 
        allSelectedValues[`CATEGORY ${index + 1}`] = checkedValues; 
      } 
    }); 
 
    Object.keys(allSelectedValues) 
      .sort((a, b) => parseInt(a.replace("CATEGORY ", "")) - parseInt(b.replace("CATEGORY ", ""))) 
      .forEach(cat => { 
        let values = allSelectedValues[cat]; 
        if (values.length > 0) { 
          categoriesText += `<p>${cat}: ${values.join(", ")}.</p>`; 
        } else { 
          categoriesText += `<p>${cat}: No symptoms chosen.</p>`; 
        } 
      }); 
 
    let result1 = "0 - 4 = Not Likely Mold-Related Illness"; 
    let result2 = "5 - 9 = Possible Mold-Related Illness"; 
    let result3 = "10+ = Probable Mold- or Biotoxin-Related Illness"; 
 
    let resultText = totalScore <= 4 ? "range1" : totalScore <= 9 ? "range2" : "range3"; 
 
    let categoriesHtml = ""; 
    Object.keys(allSelectedValues).forEach(cat => { 
      let values = allSelectedValues[cat]; 
      if (values.length > 0) { 
        categoriesHtml += ` 
          <div class="symptoms-selected-val"> 
            <p><strong>${cat}:</strong></p> 
            <ul>${values.map(val => `<li>${val}.</li>`).join("")}</ul> 
          </div> 
        `; 
      } else { 
        categoriesHtml += `<p><strong>${cat}:</strong> No symptoms chosen</p>`; 
      } 
    }); 
 
    resultsCategories.innerHTML = ` 
      <p class="score">Your Mold Risk Score: ${totalScore}</p> 
      <div class="selected-answers"> 
        <p class="h5"><strong>Your Selected Symptoms:</strong></p> 
        <div class="symptoms-values">${categoriesHtml}</div> 
      </div> 
      <div class="all-results"> 
        <p class="${resultText === 'range1' ? 'active' : 'inactive'}">${result1}</p> 
        <p class="${resultText === 'range2' ? 'active' : 'inactive'}">${result2}</p> 
        <p class="${resultText === 'range3' ? 'active' : 'inactive'}">${result3}</p> 
      </div> 
    `; 
 
    quizResult.style.display = "flex"; 
    quizBlock.style.display = "none"; 
    emailStep.style.display = "none"; 
 
    quizResult.scrollIntoView({ behavior: "smooth", block: "start" }); 
 
    sendQuizResultToKlaviyo(email, first_name, last_name, quizChoiceSelected, selected, totalScore, categoriesText); 
 
    const subscribeBtn = document.querySelector("#subscribe_bmr"); 
    if (subscribeBtn) { 
      subscribeBtn.click(); 
    } 
 
    if (resultsContainer) { 
      localStorage.setItem("questionnaireResultHTML", resultsContainer.innerHTML); 
      localStorage.setItem("questionnaireResultData", JSON.stringify({ 
        quizChoiceSelected, selected, result1, result2, result3, totalScore, categoriesText 
      })); 
    } 
 
    if (!validateQuizChoice()) { 
      return; 
    } 
 
    setTimeout(() => { 
      window.location.href = "/questionnaire-thank-you"; 
    }, 2000); 
  } 
 
  document.addEventListener("click", function(e) { 
    if (e.target.closest(".quiz-start-btn")) { 
      localStorage.removeItem("questionnaireResultHTML"); 
      localStorage.removeItem("questionnaireResultData"); 
      firstStep?.classList.remove("active"); 
      secondStep?.classList.add("active"); 
    } 
 
    if (e.target.closest(".quiz-category-group .next")) { 
      e.preventDefault(); 
      
 
      if (currentStep < allGroups.length - 1) { 
        allGroups[currentStep].classList.remove("active"); 
        steps[currentStep].classList.remove("active"); 
        steps[currentStep].classList.add("completed"); 
 
        currentStep++; 
        allGroups[currentStep].classList.add("active"); 
        steps[currentStep].classList.add("active"); 
        updateButtonStates(); 
         
        secondStep.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
      } else { 
        quizBlock.style.display = "none"; 
        emailStep.style.display = "flex"; 
        secondStep.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
      } 
    } 
 
    if (e.target.closest(".quiz-category-group .skip")) { 
      e.preventDefault(); 
        
 
      if (currentStep < allGroups.length - 1) { 
        allGroups[currentStep].classList.remove("active"); 
        steps[currentStep].classList.remove("active"); 
        steps[currentStep].classList.add("completed"); 
 
        currentStep++; 
        allGroups[currentStep].classList.add("active"); 
        steps[currentStep].classList.add("active"); 
        updateButtonStates(); 
 
        secondStep.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
      } else { 
        quizBlock.style.display = "none"; 
        emailStep.style.display = "flex"; 
        secondStep.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
      } 
    } 
 
    if (e.target.closest(".submit-email")) { 
      e.preventDefault(); 
      const first_name = firstName.value.trim(); 
      const last_name = lastName.value.trim(); 
      const email = emailInput.value.trim(); 
 
      if (!validateEmail(email)) { 
        validationMessage.textContent = "Please enter a valid email address"; 
        validationMessage.style.display = "block"; 
        return; 
      } 
 
      if (!validateQuizChoice()) { 
        return; 
      } 
 
      const selected = Array.from(document.querySelectorAll(".member_choice-option input[type='checkbox']:checked")) 
        .map(cb => cb.value); 
      validationMessage.style.display = "none"; 
 
      console.log("First Name:", first_name); 
      console.log("Last Name:", last_name); 
      console.log("Selected quiz_choice-option values:", quizChoiceSelected); 
      console.log("Selected member_choice-option values:", selected); 
      console.log("Email:", email); 
 
      showResults(email, first_name, last_name, quizChoiceSelected, selected); 
    } 
 
    if (e.target.closest(".previous")) { 
      e.preventDefault(); 
      if (resultsContainer?.style.display === "block") { 
        resultsContainer.style.display = "none"; 
        emailStep.style.display = "flex"; 
      } else if (emailStep.style.display === "flex") { 
        emailStep.style.display = "none"; 
        quizBlock.style.display = "flex"; 
        currentStep = allGroups.length - 1; 
      } else if (currentStep > 0) { 
        allGroups[currentStep].classList.remove("active"); 
        steps[currentStep].classList.remove("active"); 
 
        currentStep--; 
        allGroups[currentStep].classList.add("active"); 
        steps[currentStep].classList.add("active"); 
        updateButtonStates(); 
      } 
    } 
  }); 
 
  document.addEventListener("change", function(e) { 
    if (e.target.matches(".quiz-category-group input[type='checkbox']")) { 
      updateButtonStates(); 
    } 
  }); 
 
  const thank_Pgresult = document.querySelector("#quiz-result-wrapper"); 
  const savedHTML = localStorage.getItem("questionnaireResultHTML"); 
 
  if (savedHTML && thank_Pgresult) { 
    thank_Pgresult.innerHTML = savedHTML; 
  } else { 
    console.log("Access denied or result missing"); 
  } 
 
  initQuiz(); 
});